import { useAuthState } from "ra-core";
import React, { FC } from "react";
import { Redirect } from "react-router-dom";
import NotFound from "@/pages/NotFound";

const CatchAllUndefinedRoute: FC = () => {
  const { loaded, authenticated } = useAuthState()

  if (!loaded) { return null }

  return (
    authenticated ? <NotFound /> : <Redirect to="/login" />
  )
}

export default CatchAllUndefinedRoute;
